// Endereços da API e do servidor de jogo (de .env.<modo> no build/dev).
export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? "/api",
  gameUrl:
    import.meta.env.VITE_GAME_URL ??
    `${location.protocol === "https:" ? "wss" : "ws"}://${location.host}/game`,
};
